/*
==========================================================
OVOSANTI COVERFLOW V3
Compatible Shopify OS 2.0
==========================================================
*/

class OvosantiCoverflow {

    constructor(section) {

        this.section = section;

        this.viewport = section.querySelector('.ov-coverflow__viewport');
        this.track = section.querySelector('.ov-coverflow__track');

        this.slides = [...section.querySelectorAll('.ov-coverflow__slide')];

        this.prevButtons = [
            ...section.querySelectorAll('.ov-coverflow__arrow--prev'),
            ...section.querySelectorAll('.ov-coverflow__text-prev')
        ];

        this.nextButtons = [
            ...section.querySelectorAll('.ov-coverflow__arrow--next'),
            ...section.querySelectorAll('.ov-coverflow__text-next')
        ];

        this.progress =
            section.querySelector('.ov-coverflow__progress-fill');

        this.current =
            section.querySelector('.ov-coverflow__current');

        this.total =
            section.querySelector('.ov-coverflow__total');

        this.index = 0;

        this.totalSlides = this.slides.length;

        this.isAnimating = false;

        this.dragging = false;

        this.startX = 0;
        this.currentX = 0;

        this.autoplay =
            section.dataset.autoplay === "true";

        this.speed =
            Number(section.dataset.speed || 4) * 1000;

        this.keyboard =
            section.dataset.keyboard === "true";

        this.timer = null;

        this.resizeTimer = null;

        this.init();
    }

    init() {

        if (!this.totalSlides)
            return;

        this.render();

        this.bindButtons();

        this.bindKeyboard();

        this.bindDrag();

        this.bindResize();

        this.bindVisibility();

        this.bindShopify();

        if (this.autoplay)
            this.startAutoplay();
    }

    normalize(index){

        if(index < 0)
            return this.totalSlides - 1;

        if(index >= this.totalSlides)
            return 0;

        return index;
    }

    next(){

        if(this.isAnimating) return;

        this.goTo(this.index + 1);
    }

    prev(){

        if(this.isAnimating) return;

        this.goTo(this.index - 1);
    }

    goTo(index){

        this.index = this.normalize(index);

        this.render();

        this.restartAutoplay();
    }
        render() {

        this.isAnimating = true;

        const styles = getComputedStyle(this.section);

            const spacingDesktop =
                parseFloat(styles.getPropertyValue("--ov-card-spacing")) || 240;

            const css = getComputedStyle(this.section);

// Variables configurables desde Shopify
const rotate =
    parseFloat(css.getPropertyValue("--ov-rotate")) || 42;

const depth =
    parseFloat(css.getPropertyValue("--ov-depth")) || 260;

const scaleStep =
    parseFloat(css.getPropertyValue("--ov-scale-step")) || 0.12;

const maxVisible =
    parseInt(css.getPropertyValue("--ov-max-visible")) || 2;

// ====================================================
// NUEVO CÁLCULO RESPONSIVE
// ====================================================

const card =
    this.slides[0];

const cardWidth =
    card.offsetWidth;

// separación basada en el tamaño REAL de la tarjeta
const spacing =
    cardWidth * 0.55;

        this.slides.forEach((slide, i) => {

            let offset = i - this.index;

            // Loop infinito
            if (offset > this.totalSlides / 2) offset -= this.totalSlides;
            if (offset < -this.totalSlides / 2) offset += this.totalSlides;

            const abs = Math.abs(offset);

            // Mostrar únicamente las tarjetas cercanas
            if (abs <= maxVisible) {
                slide.classList.add("is-visible");
            } else {
                slide.classList.remove("is-visible");
            }

            slide.classList.toggle("is-active", offset === 0);

            // Capas
            slide.style.zIndex = String(100 - abs);

            // Transformaciones
            const x = offset * spacing;
            const z = -abs * depth;
            const r = offset * -rotate;
            const s = 1 - (abs * scaleStep);

            slide.style.transform =
                `translate3d(calc(-50% + ${x}px), -50%, ${z}px)
                 rotateY(${r}deg)
                 scale(${Math.max(s, 0.65)})`;

            // Opacidad
            slide.style.opacity =
                abs > maxVisible
                    ? "0"
                    : String(1 - abs * 0.25);

            // Desenfoque
            slide.style.filter =
                abs === 0
                    ? "blur(0px)"
                    : `blur(${abs * 0.8}px)`;

            slide.setAttribute(
                "aria-hidden",
                offset === 0 ? "false" : "true"
            );

            slide.tabIndex = offset === 0 ? 0 : -1;

        });

        // Contador
        if (this.current)
            this.current.textContent = this.index + 1;

        if (this.total)
            this.total.textContent = this.totalSlides;

        // Barra de progreso
        if (this.progress) {

            const percent =
                ((this.index + 1) / this.totalSlides) * 100;

            this.progress.style.width = percent + "%";
        }

        window.clearTimeout(this.animationTimer);

        this.animationTimer = window.setTimeout(() => {

            this.isAnimating = false;

        }, 650);

    }
        bindButtons() {

        this.prevButtons.forEach(button => {

            button.addEventListener("click", () => {

                this.prev();

            });

        });

        this.nextButtons.forEach(button => {

            button.addEventListener("click", () => {

                this.next();

            });

        });

    }

    bindKeyboard() {

        if (!this.keyboard) return;

        this.viewport.addEventListener("keydown", (event) => {

            switch (event.key) {

                case "ArrowLeft":

                    event.preventDefault();

                    this.prev();

                    break;

                case "ArrowRight":

                    event.preventDefault();

                    this.next();

                    break;

                case "Home":

                    event.preventDefault();

                    this.goTo(0);

                    break;

                case "End":

                    event.preventDefault();

                    this.goTo(this.totalSlides - 1);

                    break;

            }

        });

    }

    restartAutoplay() {

        if (!this.autoplay)
            return;

        this.stopAutoplay();

        this.startAutoplay();

    }
        startAutoplay() {

        if (!this.autoplay) return;

        this.stopAutoplay();

        this.timer = window.setInterval(() => {

            if (!this.dragging && !document.hidden) {
                this.next();
            }

        }, this.speed);

    }

    stopAutoplay() {

        if (this.timer) {

            clearInterval(this.timer);
            this.timer = null;

        }

    }

    bindVisibility() {

        this.section.addEventListener("mouseenter", () => {

            this.stopAutoplay();

        });

        this.section.addEventListener("mouseleave", () => {

            if (this.autoplay) {
                this.startAutoplay();
            }

        });

        document.addEventListener("visibilitychange", () => {

            if (document.hidden) {

                this.stopAutoplay();

            } else if (this.autoplay) {

                this.startAutoplay();

            }

        });

        this.viewport.addEventListener("focusin", () => {

            this.stopAutoplay();

        });

        this.viewport.addEventListener("focusout", () => {

            if (this.autoplay) {
                this.startAutoplay();
            }

        });

    }
        bindDrag() {

        const getX = (event) => {

            return event.touches
                ? event.touches[0].clientX
                : event.clientX;

        };

        const start = (event) => {

            this.dragging = true;

            this.startX = getX(event);

            this.currentX = this.startX;

            this.stopAutoplay();

            this.viewport.classList.add("is-dragging");

        };

        const move = (event) => {

            if (!this.dragging) return;

            this.currentX = getX(event);

        };

        const end = () => {

            if (!this.dragging) return;

            this.dragging = false;

            this.viewport.classList.remove("is-dragging");

            const delta = this.currentX - this.startX;

            if (Math.abs(delta) > 70) {

                if (delta > 0) {

                    this.prev();

                } else {

                    this.next();

                }

            }

            if (this.autoplay) {

                this.startAutoplay();

            }

        };

        /* Mouse */

        this.viewport.addEventListener("mousedown", start);

        window.addEventListener("mousemove", move);

        window.addEventListener("mouseup", end);

        /* Touch */

        this.viewport.addEventListener("touchstart", start, {
            passive: true
        });

        this.viewport.addEventListener("touchmove", move, {
            passive: true
        });

        this.viewport.addEventListener("touchend", end);

    }
        bindResize() {

        window.addEventListener("resize", () => {

            clearTimeout(this.resizeTimer);

            this.resizeTimer = setTimeout(() => {

                this.render();

            }, 120);

        });

    }

    getSpacing() {

        if (window.innerWidth <= 480)
            return 150;

        if (window.innerWidth <= 749)
            return 170;

        if (window.innerWidth <= 990)
            return 200;

        if (window.innerWidth <= 1400)
            return 230;

        return 250;

    }

    getRotation() {

        if (window.innerWidth < 750)
            return 38;

        return 42;

    }

    getDepth() {

        if (window.innerWidth < 750)
            return 200;

        return 260;

    }

    getScaleStep() {

        if (window.innerWidth < 750)
            return 0.10;

        return 0.12;

    }

    updateMeasurements() {

        this.spacing = this.getSpacing();

        this.rotation = this.getRotation();

        this.depth = this.getDepth();

        this.scaleStep = this.getScaleStep();

    }
        bindShopify() {

        if (typeof Shopify === "undefined") return;

        document.addEventListener("shopify:block:select", (event) => {

            const block = event.target.closest(".ov-coverflow__slide");

            if (!block) return;

            const section = block.closest(".ov-coverflow");

            if (section !== this.section) return;

            const index = Number(block.dataset.index);

            if (!Number.isNaN(index)) {
                this.goTo(index);
            }

        });

        document.addEventListener("shopify:section:load", (event) => {

            if (event.target.contains(this.section)) {

                this.render();

            }

        });

        document.addEventListener("shopify:section:reorder", () => {

            this.render();

        });

    }

    destroy() {

        this.stopAutoplay();

        clearTimeout(this.resizeTimer);

        clearTimeout(this.animationTimer);

    }

}

const ovosantiCoverflows = [];

function initOvosantiCoverflows() {

    document
        .querySelectorAll(".ov-coverflow")
        .forEach(section => {

            const exists = ovosantiCoverflows.find(item => item.section === section);

            if (exists) return;

            ovosantiCoverflows.push(
                new OvosantiCoverflow(section)
            );

        });

}

/*
==========================================================
AUTO INIT
==========================================================
*/

if (document.readyState === "loading") {

    document.addEventListener(
        "DOMContentLoaded",
        initOvosantiCoverflows
    );

} else {

    initOvosantiCoverflows();

}

/*
==========================================================
SHOPIFY THEME EDITOR
==========================================================
*/

if (typeof Shopify !== "undefined") {

    document.addEventListener(
        "shopify:section:load",
        () => {

            initOvosantiCoverflows();

        }
    );

    document.addEventListener(
        "shopify:section:reorder",
        () => {

            document
                .querySelectorAll(".ov-coverflow")
                .forEach(section => {

                    const instance = ovosantiCoverflows.find(
                        item => item.section === section
                    );

                    if (instance) {

                        instance.render();

                    }

                });

        }
    );

    document.addEventListener(
        "shopify:section:unload",
        (event) => {

            const index = ovosantiCoverflows.findIndex(
                item => item.section === event.target
            );

            if (index !== -1) {

                ovosantiCoverflows[index].destroy();

                ovosantiCoverflows.splice(index, 1);

            }

        }
    );

}